import classNames from "classnames";
import scss from "@/styles/pages/projects-partners/projects-partners-bg.module.scss";

export const wrapper = classNames(
    // Mobile
	"mobile:p-18",
    // Tablet
	"tablet:pt-18",
    "tablet:pr-8",
    // All
    "pt-10",
    "pb-8",
    scss["wrapper"]
    );

export const description = classNames(
    // Mobile
    "mobile:px-4",
    "mobile:text-xl",
    "mobile:text-center",
    // Tablet
    "tablet:text-xl",
    "tablet:text-3xl",
    "tablet:pt-5",
    // All
    "mt-5",
    "text-center",
    "font-large"
);
